import { ISiteAdminBridgeSettings } from '~src/settings/types/ISiteAdminBridgeSettings';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateSiteBridgeSettingsForSiteAdminParams {
  id: string;
  siteAdminBridgeSettings: ISiteAdminBridgeSettings;
}

export interface IUpdateSiteBridgeSettingsForSiteAdminResult {
}

export class UpdateSiteBridgeSettingsForSiteAdminRequest extends Request<IUpdateSiteBridgeSettingsForSiteAdminParams, IUpdateSiteBridgeSettingsForSiteAdminResult> {
  constructor(params: IUpdateSiteBridgeSettingsForSiteAdminParams) {
    super('updateSiteBridgeSettingsForSiteAdmin', params);
  }
}
